import { Component, Inject, afterRender } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { DarkModeService } from './services/dark-mode.service';

@Component({
    selector: 'ell-root',
    standalone: true,
    imports: [RouterOutlet, MenuComponent, FooterComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'Data Donation Project';

    constructor(@Inject(DOCUMENT) private document: Document, private darkModeService: DarkModeService) {
        // Using the DOM API to only render on the browser instead of on the server
        let head: HTMLHeadElement;
        afterRender(() => {
            if (head === this.document.head) {
                // already setup!
                return;
            }
            head = this.document.head;
            const style = this.document.createElement('link');
            style.rel = 'stylesheet';
            this.document.head.append(style);

            this.darkModeService.theme$.subscribe(theme => {
                this.document.documentElement.setAttribute('data-bs-theme', theme);
                style.href = `${theme}.css`;
            });
        });
    }

}
